import { IErrorProps } from './IError';
import LogoMacRADesignNegative from '../../../app/images/MacRA-Design_COMPLETE-LOGO-negative.png';
import LogoMaccaferri from '../../../app/images/LogoMaccaferri.svg';
import { useAppDispatch } from '../../../reduxService/hooks';
import { useNavigate } from 'react-router-dom';
import { cleanProjectInfo } from '../../store/projectInfo/projectInfoSlice';
import { cleanProject } from '../../MACRA_1/store/project/projectSlice';
import { endpoint } from '..';
import Button from '../../../components/Button/Button';
import { useTranslation } from 'react-i18next';

const PageNotFound = (props: IErrorProps) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const navigateAfterError = () => {
        dispatch(cleanProjectInfo());
        dispatch(cleanProject());
        navigate(endpoint.home);
    };
    return (
        <header id='HeaderMacra1'>
            <div className='head'>
                <div className='leftHead'>
                    <img className='logoMacra' src={LogoMacRADesignNegative} alt='Maccaferri logo header' />
                    <span className='title'>
                        <h5>{t('header_title')}</h5>
                    </span>
                </div>
                <a className='backToHub' href={process.env.EDESIGN_PORTAL_URL}>
                    {t('header_back_to_hub')}
                </a>
                <img className='cursor-pointer logoMaccaferri' src={LogoMaccaferri} alt='Logo Maccaferri' onClick={navigateAfterError} />
            </div>
            <div className='error-boundary'>
                <h1>{t('page_not_found')}</h1>
                <Button className='d-flex justify-content-end mb-3' onClick={navigateAfterError}>
                    {t('header_label_home')}
                </Button>
            </div>
        </header>
    );
};
export default PageNotFound;
